import { useEffect, useState } from 'react';
import apiEmpresa from '../../api/apiEmpresa';
import { Box, Typography } from '@mui/material';

const LogoEmpresa: React.FC = () => {
  const [urlImagem, setUrlImagem] = useState<string | undefined>('');
  const [nomeEmpresa, setNomeEmpresa] = useState<string | undefined>('');

  useEffect(() => {
    const getLogoEmpresaDEPRECATED = async () => {
      try {
        const res = await apiEmpresa.getLogoEmpresa();
        setUrlImagem(res);
      } catch (erro: any) {
        console.error(erro);
      }
    };

    const getLogoEmpresa = async () => {
      try {
        const res = await apiEmpresa.getDadosPublicosEmpresa();
        setUrlImagem(res.urlImagem);
        setNomeEmpresa(res?.nome?.trim() || '');
      } catch (erro: any) {
        getLogoEmpresaDEPRECATED();
        console.error(erro);
      }
    };

    getLogoEmpresa();
  }, []);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" my={2} textAlign="center">
      {urlImagem ? (
        <Box
          component="img"
          src={urlImagem}
          alt="Logo empresa"
          sx={{
            maxWidth: '100%',
            maxHeight: 120,
            objectFit: 'contain'
          }}
        />
      ) : (
        <Typography
          variant="h6"
          color="text.primary"
          sx={{
            wordBreak: 'break-word',
            maxWidth: 350
          }}
        >
          {nomeEmpresa}
        </Typography>
      )}
    </Box>
  );
};

export default LogoEmpresa;
